import type { AppTheme } from "@/constants/theme";

export const PUBLIC_ASSETS = {
  socialPreview: "/social-preview.png",
  heroMark: {
    dark: "/figma-hero-mark-dark.svg",
    light: "/figma-hero-mark-light.svg",
  },
  logoMark: {
    dark: "/logo-mark-dark-glow.svg",
    light: "/logo-mark-light-glow.svg",
  },
  storeIcon: {
    dark: "/logo-mark-dark.png",
    light: "/logo-mark-light.png",
  },
  shopElementIcon: "/shop-element-icon.svg",
  loginImage: "/login-image.png",
  pricingArt: {
    dark: "/price-art-dark.png",
    light: "/price-art-white.png",
  },
  passwordVisibility: "/visibility.svg",
  passwordVisibilityOff: "/visibility_off.svg",
  wordmark: {
    dark: "/figma-wordmark-dark.svg",
    light: "/figma-wordmark-light.svg",
  },
} as const;

export function getHeroMarkAsset(theme: AppTheme): string {
  return PUBLIC_ASSETS.heroMark[theme];
}

export function getPricingArtAsset(theme: AppTheme): string {
  return PUBLIC_ASSETS.pricingArt[theme];
}

export function getWordmarkAsset(theme: AppTheme): string {
  return PUBLIC_ASSETS.wordmark[theme];
}
